import type { ReactElement } from "react";

import { formatDate, shortMonthDayAndYear, TruncatedTextCell } from "@similarweb/pro-logic-components";

import { NO_DATA_HYPHEN } from "app/pages/sales-intelligence/constants/common";
import type { ContactSearchEntry } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/common";
import getContactPrivateData from "app/pages/sales-intelligence/sub-modules/contacts-search/utils/getContactPrivateData";

interface IProps {
    rowData: ContactSearchEntry;
}

const ContactLastUpdateCell = ({ rowData }: IProps): ReactElement => {
    const privateData = getContactPrivateData(rowData);

    return (
        <TruncatedTextCell>
            {privateData?.lastUpdated
                ? formatDate(privateData?.lastUpdated, undefined, shortMonthDayAndYear)
                : NO_DATA_HYPHEN}
        </TruncatedTextCell>
    );
};

export default ContactLastUpdateCell;
